export default "__VITE_ASSET__DK7v0hnn__"